import React from "react";
import MediaDetails from "../../media/MediaDetails";
// import MediaDetails from "../../../media/MediaDetails";

export default function VideoDetail() {
  return <MediaDetails mediaType="videos" />;
}
